import { Component } from "react";
import Table from 'react-bootstrap/Table';


class DemographyTable extends Component{
    static Title = "General demographics"
    render() {
        return (
            <Table className='border'>
                    <thead className='smoke30-bg'>
                            <tr>
                                <th></th>              
                                <th></th>              
                                <th colSpan="3" className="text-center">Gender (%)</th>              
                                <th colSpan="3" className="text-center">Age at implantation (years)</th>              
                            </tr>
                        </thead>                          
                        <thead className='smoke30-bg'>
                            <tr>
                                <th>Study</th>              
                                <th>#Subject</th>              
                                <th>Female</th>              
                                <th>Male</th>              
                                <th>Unknown</th>              
                                <th>Min</th>              
                                <th>Median</th>              
                                <th>Max</th>              
                            </tr>
                        </thead>
                      
                        <tbody>
                            <tr>
                                <td>CLTD5685</td>
                                <td>100</td>
                                <td>37.00</td>
                                <td>63.00</td>
                                <td>0.00</td>
                                <td>23</td>
                                <td>71</td>
                                <td>93</td>
                            </tr>
                            <tr>
                                <td>CLTD5595</td>
                                <td>119</td>
                                <td>52.11</td>
                                <td>47.89</td>
                                <td>0.00</td>
                                <td>19</td>
                                <td>68</td>
                                <td>90</td>
                            </tr>
                            <tr>
                                <td>CAM5717</td>
                                <td>1282</td>
                                <td>41.88</td>
                                <td>57.95</td>
                                <td>0.17</td>
                                <td>18</td>
                                <td>68</td>
                                <td>102</td>
                            </tr>       
                            <tr>
                                <td>CEL5277</td>
                                <td>412</td>
                                <td>42.00</td>
                                <td>80.00</td>
                                <td>0.00</td>
                                <td>18</td>
                                <td>59</td>
                                <td>98</td>
                            </tr>                                                        
                        </tbody>
                        
            </Table>);
    }
}
export default DemographyTable 